<template>
  <div class="tabs">

    <!-- clickable tabs -->
    <template v-for="(item, index) in props.tabs">
      <AtomsTextLink v-if="index < props.tabs.length - (props.lastTabInactive ? 1 : 0)" class="tabs__tab" :class="[ props.currentIndex === index && props.activeTabClass ? props.activeTabClass : '', { 'tabs__tab--current': props.currentIndex === index, 'tabs__tab--elapsed': typeof props.maxEnabledIndex === 'undefined' || index < props.maxEnabledIndex + 1, 'tabs__tab--disabled': index > props.maxEnabledIndex }]" :to="typeof props.maxEnabledIndex === 'undefined' || index <= props.maxEnabledIndex ? item.url : null" @click="tabSelected(index)">
        <div v-if="props.showIndex" class="tabs__index">{{ index + 1 }}</div>
        <span class="tabs__label" :class="{ 'mb-auto': props.showIndex }">{{ item.label }}</span>
      </AtomsTextLink>
    </template>

    <template v-if="props.lastTabInactive">
      <!-- last tab inactive -->
      <div class="tabs__tab tabs__tab--disabled">
        <div v-if="props.showIndex" class="tabs__index">{{ props.tabs.length }}</div>
        <span class="tabs__label" :class="{ 'mb-auto': props.showIndex }">{{ props.tabs[props.tabs.length - 1].label }}</span>
      </div>
    </template>

  </div>
</template>
<script setup>

const props = defineProps({
  tabs: Array,
  currentIndex: Number,
  maxEnabledIndex: Number,
  showIndex: Boolean,
  lastTabInactive: Boolean,
  activeTabClass: String
});

const emit = defineEmits(['tabSelected']);

const tabSelected = (index) => {
  emit('tabSelected', index);
}

</script>
<style lang="postcss">
.tabs {
  @apply flex;

  &__tab {
    @apply flex-1 flex flex-col items-center justify-center gap-x-4 gap-y-2 py-4 px-1 font-bold border-t-4 border-t-neutral-500 border-r border-r-neutral-50 text-neutral-50 bg-neutral-500 cursor-pointer desktop:flex-row desktop:py-5 hover:no-underline;

    &--current {
      @apply -ml-[1px] border-t-4 border-primary-500 bg-transparent text-neutral-500;

      .tabs__index {
        @apply !border-neutral-500 !bg-transparent;
      }
    }

    &--elapsed {
      .tabs__index {
        @apply border-primary-500 bg-primary-500;
      }
    }

    &--disabled {
      @apply cursor-not-allowed;
    }

    &:last-child {
      @apply border-r-0;
    }
  }

  &__index {
    @apply flex items-center justify-center aspect-square w-5 leading-4 text-xs border border-neutral-50 rounded-full tablet:text-sm tablet:w-6 desktop:text-base desktop:w-7 desktop:leading-4;
  }

  &__label {
    @apply text-xs tracking-normal text-center tablet:text-base desktop:text-lg;
  }


}
</style>